'use client';

import { ChevronDown } from 'lucide-react';
import { useCmsData } from '@/lib/CmsContext';
import { faqsByIds, faqsForPage } from '@/lib/faqUtils';

/**
 * FAQ accordion — native <details> so open/close works without React hydration (prod proxy).
 *
 * @param {{ title?: string, pageSlug?: string, faqIds?: number[] }} props
 */
export default function FaqSection({ title = 'Часті запитання', pageSlug = '/', faqIds }) {
  const cms = useCmsData();
  const resolved = faqIds?.length
    ? faqsByIds(cms?.faq_item, faqIds)
    : faqsForPage(cms?.faq_item, pageSlug);
  const faqs = resolved.map((f) => ({
    q: f.question,
    a: f.answer,
  }));

  if (!faqs.length) {
    return null;
  }

  return (
    <section className="bg-background py-20 lg:py-28" data-grv-faq>
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-14">
          <span className="text-gold text-xs font-semibold uppercase tracking-widest">Питання та відповіді</span>
          <h2 className="text-3xl sm:text-4xl font-black text-foreground mt-3 mb-4">
            {title}
          </h2>
          <div className="gold-divider" />
        </div>

        <div className="space-y-3" data-grv-faq-list>
          {faqs.map((faq, idx) => (
            <details
              key={`${faq.q}-${idx}`}
              data-grv-faq-item
              className="grv-faq-item bg-card border border-border rounded-xl overflow-hidden transition-all duration-300 open:border-gold/50"
            >
              <summary className="grv-faq-summary w-full flex items-center justify-between p-5 text-left gap-4 cursor-pointer list-none">
                <span className="grv-faq-q font-semibold text-sm text-foreground transition-colors">
                  {faq.q}
                </span>
                <ChevronDown className="grv-faq-chevron w-5 h-5 text-gold shrink-0 transition-transform duration-300 pointer-events-none" />
              </summary>
              <div className="grv-faq-a px-5 pb-5 text-muted-foreground text-sm leading-relaxed border-t border-border pt-4">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
